import React from "react";
import { useQuery } from "@apollo/client/react";
import { GET_SHIPMENT_QUERY } from "src/constants/graphql/queries";
import InboundChargesSummaryModal from "src/components/project/inbound/InboundChargesSummaryModal";
import StatusDialog from "./StatusDialog";

export default function InboundChargesSummaryModalWrapper({ inboundChargesSummaryId, onClose }) {
  const { data: shipmentData, loading, error } = useQuery(GET_SHIPMENT_QUERY, {
    variables: { id: inboundChargesSummaryId },
    skip: !inboundChargesSummaryId,
  });

  const shipment = shipmentData?.shipment;
  const project = shipment?.project;

  if (!loading && error) {
    return (
      <StatusDialog
        title="Failed to load Inbound Charges Summary"
        message="You may not have access to view this shipment, or it no longer exists."
        onClose={onClose}
      />
    );
  }

  if (shipment) {
    return <InboundChargesSummaryModal shipment={shipment} project={project} onClose={onClose} />;
  }

  return null;
}
